import React, { useContext } from 'react';
import { Modal } from 'antd';
import { AppContext, AppContextInterface } from '../../../../AppProvider';
import { useWogPay } from './useWogPay';
import RefuelHeader from './RefuelHeader';
import RefuelBody from './RefuelBody';
import RefuelFooter from './RefuelFooter';

interface IFRefuelModal {
	visible: boolean;
	onClose: () => void;
}

const RefuelModal: React.FC<IFRefuelModal> = ({ visible, onClose }) => {
	const { wallet, getUsersData } = useContext(AppContext) as AppContextInterface;
	const pay = useWogPay({
		visible,
		onClose,
		wallet,
		onFuelled: () => getUsersData(),
	});

	return (
		<Modal
			title={<RefuelHeader pay={pay} />}
			visible={visible}
			onCancel={pay.close}
			className="refuel-modal"
			width={600}
			destroyOnClose
			maskClosable={false}
			footer={<RefuelFooter pay={pay} />}
		>
			<RefuelBody pay={pay} />
		</Modal>
	);
};

export default RefuelModal;
